import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function ChecklistItem({ children, ...props }: FlexProps) {
  return (
    <Flex
      align="center"
      borderBottom="1px"
      borderColor="brand.border.extraLight"
      gap="smallest"
      h="bigger"
      textStyle={{ base: "caption2", lg: "caption1" }}
      {...props}
    >
      {children}
    </Flex>
  );
}
